export enum ADDRESS_PARTS {
  address_1 = 'address_1',
  address_2 = 'address_2',
  city = 'city',
  country_code = 'country_code',
  postal_code = 'postal_code',
  province = 'province',
}

type AddressEnumKeys = keyof typeof ADDRESS_PARTS;

const DEFAULT_ADDRESS_FIELDS_ORDER = [
  ADDRESS_PARTS.address_1,
  ADDRESS_PARTS.address_2,
  ADDRESS_PARTS.city,
  ADDRESS_PARTS.province,
  ADDRESS_PARTS.postal_code,
];

export type Address = {
  [key in AddressEnumKeys]: string;
};

const DEFAULT_DELIMITER = ', ';

export class AutosuggestAddress {
  private address: Address;
  private delimiter: string;

  constructor(address: Address, delimiter?: string) {
    this.address = address;
    this.delimiter = delimiter ?? DEFAULT_DELIMITER;
  }

  parse(fields_order?: ADDRESS_PARTS[]): string {
    const order = fields_order ?? DEFAULT_ADDRESS_FIELDS_ORDER;
    return order.map((field) => this.address[field]).join(this.delimiter);
  }
}
